import React from 'react';

const DisneyIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 25.698 21'
      {...props}
    >
      <path
        className='subheader__container-link-icon'
        d='M20.874 0a4.8 4.8 0 00-4.748 5.655 7.974 7.974 0 00-6.554 0 4.862 4.862 0 10-3.988 3.928 8.025 8.025 0 1014.53 0A4.822 4.822 0 1020.874 0z'
        fill='#fff'
      />
    </svg>
  );
};

export default DisneyIcon;
